export default __webpack_public_path__ + "static/media/Animals05.76a939c2.jpg";